import { createComposer } from "@/lib/create-composer";
import type { OpenEmailOptions } from "./email.types";
import { EmailComposerSheet } from "./components/email-composer-sheet";

const { Provider, useComposer } = createComposer<OpenEmailOptions>(
  EmailComposerSheet,
  "useEmailComposer",
);

export const EmailComposerProvider = Provider;

// Open the shared email sheet with a recipient (+ optional prefilled subject/body).
export function useEmailComposer() {
  const { open } = useComposer();
  return { openEmail: open };
}
